import { render, staticRenderFns } from "./PerishablesDialog.vue?vue&type=template&id=cef5aeda"
import script from "./PerishablesDialog.vue?vue&type=script&lang=js"
export * from "./PerishablesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports